import {
  AchievementCompleteRulePeriod,
  AchievementCompleteRulePeriodUnion,
} from "types/achievements";

const { OVERALL, LAST_DAY, DAY, WEEK, MONTH, YEAR, STREAK } =
  AchievementCompleteRulePeriod;

export const limitAchievementsArray: {
  value: AchievementCompleteRulePeriodUnion;
  label: string;
}[] = [
  { value: OVERALL, label: "overall" },
  { value: LAST_DAY, label: "lastxDays" },
  { value: STREAK, label: "streak" },
];

export const getValueAdornment = (
  type?: AchievementCompleteRulePeriodUnion,
): string => {
  switch (type) {
    case OVERALL:
      return "attributeValue";
    case LAST_DAY:
      return "eventAttributePerXDays";
    case DAY:
      return "everyDay";
    case WEEK:
      return "everyWeek";
    case MONTH:
      return "everyMonth";
    case YEAR:
      return "everyYear";
    default:
      return "";
  }
};

export const getPluralizedTimeframe = (
  periodType?: AchievementCompleteRulePeriodUnion,
) => {
  switch (periodType) {
    case "day":
      return "days";
    case "week":
      return "weeks";
    case "month":
      return "months";
    case "year":
      return "years";
    default:
      return "";
  }
};
